const formatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
});

export const displayDate = (date: string | number | Date): string => {
  if (!date) {
    return '';
  }
  return formatter.format(new Date(date));
};

export const isValidIsoDate = (date: unknown): boolean => {
  if (typeof date === 'string' && date.length >= 10) {
    return !isNaN(new Date(date).getTime());
  }

  return false;
};
